import { Spin } from "antd";
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";

const Spinner = ({ color = "blue" }) => (
  <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color }} spin />} />
);

export default Spinner;
